import type {ActionResponseOperation} from '@models/enums/action-response.enum'

export type ActionResponse<T> = {operation: ActionResponseOperation; data?: T; error?: any; action?: string}

export enum ActivityEffectAction {
  FINISH = 'ActivityFinish',
  SAVE = 'ActivitySave',
  DELETE_TASKS_ANSWERS = 'ActivityDeleteTasksAnswers',
}
